export default "__VITE_ASSET__BxVJ9lqx__"